module.exports = __webpack_public_path__ + "img/logo-Symbol.c91930b4.png";